import { Box, CircularProgress } from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";

import { TDateISO } from "api/common/types/datetime.types";
import { Product } from "api/memberPortal/project/product/product.types";
import { useGetProgressPointsByPidQuery } from "api/memberPortal/project/progressPoints/progressPoints.api";

import EventsList from "./EventsList";

interface EstimatedDate {
  estimated_date: TDateISO;
}
const formatDates = (dates: EstimatedDate[], defaultDate: TDateISO | null) => {
  if (dates.length === 0) return defaultDate ? [defaultDate] : [];

  return dates.map((date) => date.estimated_date);
};

interface EventDatesCellProps {
  product: Product;
}
const EventDatesCell = ({ product }: EventDatesCellProps) => {
  const { data: progressPoints, isLoading } = useGetProgressPointsByPidQuery(
    product.product_id || skipToken,
  );

  if (isLoading || !progressPoints) return <CircularProgress size={20} />;

  const pp6 = progressPoints[5];
  const pp6SubmissionDates = formatDates(pp6.submission_dates, null);
  const pp6EstimatedCompletionDates = formatDates(
    pp6.est_completion_dates,
    product.evaluator_checkout_date,
  );

  const pp7 = progressPoints[6];
  const pp7SubmissionDates = formatDates(pp7.submission_dates, null);
  const pp7EstimatedCompletionDates = formatDates(
    pp7.est_completion_dates,
    product.validator_checkout_date,
  );

  return (
    <Box
      display="grid"
      gridTemplateColumns="repeat(2, 1fr)"
      columnGap={4}
      sx={{
        width: "250px",
      }}
    >
      <EventsList
        dateList={pp6EstimatedCompletionDates}
        progressPoint={6}
        header="Estimated"
      />
      <EventsList
        dateList={pp7EstimatedCompletionDates}
        progressPoint={7}
        header="Estimated"
      />

      <EventsList
        dateList={pp6SubmissionDates}
        progressPoint={6}
        header="Completed"
      />
      <EventsList
        dateList={pp7SubmissionDates}
        progressPoint={7}
        header="Completed"
      />
    </Box>
  );
};
export default EventDatesCell;
